import {
  // Category
  getCategory,
  getOneCategory,
  getSubCategoryClient,
  addCategory,
  putCategory,
  deleteCategory,
  // SubCategory
  getSubCategory,
  getOneSubCategory,
  addSubCategory,
  putSubCategory,
  deleteSubCategory,
  // Post
  getAllPosts , 
  getPost,
  getOnePost,
  addPost,
  putPost,
  deletePost,
  // Post-files
  getFilesByPost,
  addFilesToPost,
  deleteFilesFromPost
} from "../../api/help";

export default {
  // Category
  FETCH_SUB_CATEGORY_CLIENT({ commit }, a) {
    return getSubCategoryClient(a);
  },
  FETCH_ONE_CATEGORY({ commit }, a) {
    return getOneCategory(a);
  },
  FETCH_CATEGORY_LIST({ commit }, a) {
    return new Promise((resolve, reject) => {
      getCategory(a)
        .then(res => {
          commit("SET_CATEGORY_LIST", res.data.results);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  ADD_CATEGORY_LIST({ commit }, a) {
    return new Promise((resolve, reject) => {
      addCategory(a)
        .then(res => {
          commit("ADD_CATEGORY_LIST", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  EDIT_CATEGORY_LIST({ commit }, a) {
    return new Promise((resolve, reject) => {
      putCategory(a)
        .then(res => {
          commit("EDIT_CATEGORY_LIST", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  DELETE_CATEGORY_LIST({ commit }, a) {
    return new Promise((resolve, reject) => {
      deleteCategory(a)
        .then(res => {
          commit("DELETE_CATEGORY_LIST", a);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // SubCategory
  FETCH_SUB_CATEGORY_LIST({ commit }, a) {
    return getSubCategory(a);
  },
  FETCH_ONE_SUB_CATEGORY_LIST({ commit }, a) {
    return getOneSubCategory(a);
  },
  ADD_SUB_CATEGORY_LIST({ commit }, a) {
    return addSubCategory(a);
  },
  EDIT_SUB_CATEGORY_LIST({ commit }, a) {
    return putSubCategory(a);
  },
  DELETE_SUB_CATEGORY_LIST({ commit }, a) {
    return deleteSubCategory(a);
  },
  // Post
  FETCH_ALL_POST_LIST({ commit }, a) {
    return getAllPosts(a);
  },
  FETCH_POST_LIST({ commit }, a) {
    return getPost(a);
  },
  FETCH_ONE_POST_LIST({ commit }, a) {
    return getOnePost(a);
  },
  FETCH_FILES_BY_POST({ commit }, a) {
    return getFilesByPost(a);
  },
  ADD_FILES_TO_POST({ commit }, a) {
    return addFilesToPost(a);
  },
  DELETE_FILES_FROM_POST({ commit }, a) {
    return deleteFilesFromPost(a);
  },
  ADD_POST_LIST({ commit }, a) {
    return addPost(a);
  },
  EDIT_POST_LIST({ commit }, a) {
    return putPost(a);
  },
  DELETE_POST_LIST({ commit }, a) {
    return deletePost(a);
  }
};
